import React from "react";
import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
} from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import { css } from "./styles";

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 512,
            width: 250,
        },
    },
};

export const SelectMultiCheckbox = ({ itens, disabled, selectedIds, setSelectedIds }) => {
    const styles = css();

    const handleChange = (event) => {
        const { value } = event.target;
        setSelectedIds(value);
    };

    return (
        <div>
            <FormControl sx={{ width: 300 }} disabled={disabled}>
                <InputLabel id="multiple-checkbox-label" className={styles.label}>
                    ID dos produtos
                </InputLabel>
                <Select
                    className={styles.select}
                    IconComponent={() => <ArrowDropDown style={{ display: "none" }} />}
                    id="multiple-checkbox"
                    labelId="multiple-checkbox-label"
                    multiple
                    value={selectedIds}
                    onChange={handleChange}
                    input={<OutlinedInput label="Id dos produtos" />}
                    MenuProps={MenuProps}
                    renderValue={(selected) => selected.map((item) => `${item.id}, `)}
                >
                    {itens &&
                        itens.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                <Checkbox checked={selectedIds.indexOf(item) > -1} />
                                <ListItemText primary={`${item.id} - ${item.nome}`} />
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </div>
    );
};
